<template>
  <Ani class="section user-reviews" :class="locale=='en-US'?'en':''" ID="ani-user-reviews">
    <div class="wrap">
      <h2 class="font36 heading">{{ props.heading }}</h2>
      <swiper
        class="swiper"
        :modules="[Autoplay, Pagination]"
        :autoplay="{ delay: 3000 }"
        :loop="true"
        :pagination="{ clickable: true }"
        :breakpoints="{
          0: {
            slidesPerView: 1,
            spaceBetween: 12
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 24
          }
        }"
      >
        <SwiperSlide class="swiper-slide" v-for="(item, index) in props.reviews" :key="index">
          <div class="review-item">
            <div class="user-info">
              <div class="avatar">
                <!-- <img loading="lazy" :src="item.avatar || userAvatar" alt="" /> -->
                <el-image :src="item.avatar" lazy class="has-backstop image" alt="avatar">
                  <template #error>
                    <div class="no-pic">
                      <img src="@/assets/images/iconSvg/logo_no_pic.svg" alt="item.title" />
                    </div>
                  </template>
                </el-image>
              </div>
              <div class="info">
                <div class="font24 bold name MultiLine1">{{ item.userName }}</div>
                <div class="font16 desc">
                  <span class="ip MultiLine1">{{ item.address }}</span>
                  <span class="year MultiLine1">{{ item.desc }}</span>
                </div>
              </div>
            </div>
            <div class="star-list">
              <!-- 根据rating渲染星星， 星星有半个比如4.5 -->
              <div
                class="star"
                v-for="value in Math.ceil(item.rating || 0)"
                :key="value"
                :style="{ width: value <= (item.rating || 0) ? 'var(--star_size)' : 'calc(var(--star_size) * 0.5)' }"
              >
                <img :src="iconStar" alt="" />
              </div>
            </div>
            <p class="font16 " :class="{'MultiLine3':locale=='zh-CN'}">{{ item.content }}</p>
          </div>
        </SwiperSlide>
      </swiper>
    </div>
  </Ani>
</template>

<script setup lang="ts">
import userAvatar from '@/assets/images/weather/user.webp'
import iconStar from '@/assets/images/weather/star.webp'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import type { PropType } from 'vue'
import type { UserReviews } from '~/types'

import { useI18n } from 'vue-i18n'
const { locale,t } = useI18n()

const props = defineProps({
  heading: {
    type: String,
    default: ''
  },
  reviews: {
    type: Array as PropType<UserReviews['dataList']>,
    default: () => []
  }
})
</script>

<style lang="scss" scoped>
@use '@/assets/css/weather.scss';
</style>
